import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import Select from "react-select";
import {Consts} from "../pages/consts";
import {useContext} from "react";
import InitContext from "../pages/InitContext";

const SortAndAddNew = ({showSorting, sortConfig, onAddDrug, loading, setSortConfig}) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  const sortOptions = [
    {value: "startDate", label: t("start_date")},
    {value: "productName", label: t("product_name")},
  ];

  const handleSortChange = (key) => {
    const ascending = sortConfig?.key === key ? !sortConfig?.ascending : true;
    setSortConfig({key, ascending});
  };

  const allowedChanging = context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT;

  return(
    <div className="w3-row w3-padding-small">
      <div className="w3-col s2">
        {showSorting && (<label className="w3-right w3-padding-small w3-right">{t("sort_by")}: </label>)}
      </div>
      <div className="w3-col s7">
        {showSorting && (
          <div className="flex-aligned-items">
            <Select
              onChange={(selectedOption) => handleSortChange(selectedOption?.value) }
              value={sortOptions?.find((option) => option?.value === sortConfig?.key)}
              options={sortOptions}
              placeholder={t("select")}
              className="custom-select"
              classNamePrefix="custom-select"
            />
            <FontAwesomeIcon
              onClick={() => handleSortChange(sortConfig?.key)}
              icon={sortConfig?.ascending ? faSortUp : faSortDown}
              className="w3-left w3-padding-small"
            />
          </div>
        )}
      </div>
      <div className="w3-col s3">
        {(onAddDrug && !loading && allowedChanging) && (
          <button
            type="button"
            className="w3-btn w3-round-xlarge w3-theme-d5 responsive-button"
            onClick={onAddDrug}
          >
            <FontAwesomeIcon icon={faPlus} /> {t("add_new_medicine")}
          </button>
        )}
      </div>
    </div>
  );
}

export default SortAndAddNew;